export default __webpack_public_path__ + "static/media/Snd_CC.ebced51d.mp3";